import React from 'react';

import { BUSINESS_TOOL_SUB_SECTIONS } from 'constants/businessTool';
import { useBusinessToolStore } from 'store/useBusinessToolStore';
import { getActiveSubSection } from 'store/useBusinessToolStore/selectors';

import { CompanyHistory } from './CompanyHistory';
import { GeneralInfo } from './GeneralInfo';
import { MissionAndVision } from './MissionAndVision';
import { SWOT } from './SWOT';
import { IForBankFormSubSections } from '../forBankSections';

const SUB_SECTIONS: IForBankFormSubSections = {
  [BUSINESS_TOOL_SUB_SECTIONS.ABOUT_COMPANY.GENERAL_INFO]: GeneralInfo,
  [BUSINESS_TOOL_SUB_SECTIONS.ABOUT_COMPANY.COMPANY_HISTORY]: CompanyHistory,
  [BUSINESS_TOOL_SUB_SECTIONS.ABOUT_COMPANY.MISSION_AND_STRATEGY]: MissionAndVision,
  [BUSINESS_TOOL_SUB_SECTIONS.ABOUT_COMPANY.SWOT]: SWOT,
};

export const AboutCompany: React.FC = () => {
  const activeSubSection = useBusinessToolStore(getActiveSubSection);

  if (!activeSubSection) {
    return null;
  }

  const ActiveComponent = SUB_SECTIONS?.[activeSubSection] || null;

  if (ActiveComponent) {
    return <ActiveComponent />;
  }

  return null;
};
